import MicroModal from 'micromodal';
import { trimHTMLtoCharCount, trimHTMLtoWordCount, scrollToTopOfElement } from './utilities.js';
import 'slick-carousel';
import './components/hours';
import './components/hover-content.js'
import './components/tabs';
import './components/collapse';
import './components/accordions';
import './components/toggles';
import './components/cascade';
import './components/search-filters';
import './components/theme-filters';
import './components/theme-modals';
import './components/popup';
import './components/garage/index';
import './sliders/hero';
import './sliders/home-featured';
import './sliders/home-reviews';
import './sliders/home-promos';
import './sliders/home-bnp';
import './sliders/blog-slider';
import './sliders/showroom-sliders';
import './async/featured-slider';
import './components/payment-calc/oem-calculator';
import './components/payment-calc/payment-calculations';
import './components/payment-calc/payment-calculator';
import './page/vdp';
import './page/garage';
import './page/promos';
import './page/employment';
import './showroom/index.js';
import './showroom/configure.js';
import './showroom/configure-oem.js';
import './showroom/summary-oem.js';
import './showroom/bottom-bar.js';
import './showroom/summary.js';

MicroModal.init();

(function ($, undefined) {

  $('.js-scroll-to').on('click', function () {
    const elementId = $(this).data('scroll-id');
    scrollToTopOfElement($(`#${elementId}`).closest('.scroll-container'), 100);
  });

  $('.showcase').on('click', '.link', function (e) {
    e.preventDefault();
    if ($(this).hasClass('link_select')) {
      $(this).toggleClass('active');
    }
  });

  $('.js-trim-text').each(function () {
    const wCount = $(this).data('wordcount');
    const cCount = $(this).data('charcount');
    let paragraphs = $(this).data('text');
    if (wCount) {
      paragraphs = trimHTMLtoWordCount(paragraphs, wCount);
    }
    if (cCount) {
      paragraphs = trimHTMLtoCharCount(paragraphs, cCount);
    }
    $(this).html(paragraphs);
  });

  $('.js-scroll-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
  });

  $('.js-highlight-parse').each(function () {
    // grab word to be parsed
    let parse = $(this).attr('data-parse');

    // check for parsing flag
    if (parse !== 'undefined' && parse !== false) {
      let parseText = $(this).text().trim();
      let parseArray = parseText.split(' ');

      // will parse if string is more than one word
      if (parseArray.length > 1) {

        let index = 0;
        if (parse === 'last') {
          index = parseArray.length - 1;
        } else if (parse === 'first') {
          index = 0;
        } else {
          index = parse - 1;
        }

        // reconstruct the text
        $(this).empty();
        parseText = '';
        // go through each word and assemble html with (the target word wrapped in span)  
        for (let i = 0; i < parseArray.length; i++) {
          if (i == index) {
            parseText = parseText + '<span class="highlight">' + parseArray[i] + '</span> ';
          } else {
            parseText = parseText + parseArray[i] + ' ';
          }
        }

        $(this).html(parseText);
      }
    }
  });


  
})(jQuery);
